import React from 'react';
import styled from 'styled-components';

import { device, colors, rem, em } from '../lib/global-styles';
import { Title } from './Title';
import tvImage from '../images/img-tv.svg';
import cardImage from '../images/img-card.svg';
import channelsImage from '../images/img-channels.svg';
import scheduleImage from '../images/img-schedule.svg';

const AdvantagesWrapper = styled.div`
  ul {
    margin-top: ${em(35)};
    list-style: none;
    display: flex;
    flex-wrap: wrap;

    li {
      width: 25%;
      box-sizing: border-box;
      background-repeat: no-repeat;
      background-position: top center;
      padding-top: ${rem(185)};
      margin-bottom: ${em(35)};

      p {
        color: ${colors.black};
        text-align: center;
        font-size: ${rem(16)};
        width: ${em(196)};
        margin: auto;
      }
    }
  }

  h3 {
    color: ${colors.primary};
    font-size: ${rem(16)};
    line-height: ${rem(24)};
    text-align: center;
  }

  @media ${device.mobile} {
    display: none;
  }
`;

const Economy = styled.li`
  background-image: url(${tvImage});
`;

const Control = styled.li`
  background-image: url(${cardImage});
`;

const Channels = styled.li`
  background-image: url(${channelsImage});
`;

const Practicality = styled.li`
  background-image: url(${scheduleImage});
`;

const Advantages = () => {
  return (
    <AdvantagesWrapper>
      <p>Com o Recorrente, você garante a sua diversão todo mês e ainda economiza</p>
      <Title>Conheça os benefícios de ter o Recorrente</Title>
      <ul>
        <Economy>
          <h3>ECONOMIA</h3>
          <p>É mais barato que fazer uma compra avulsa</p>
        </Economy>
        <Control>
          <h3>CONTROLE</h3>
          <p>Não compromete o limite do seu cartão de crédito</p>
        </Control>
        <Channels>
          <h3>MAIS CANAIS</h3>
          <p>Você pode ganhar canais extras</p>
        </Channels>
        <Practicality>
          <h3>PRATICIDADE</h3>
          <p>A renovação é automática todo mês</p>
        </Practicality>
      </ul>
    </AdvantagesWrapper>
  );
};

export default Advantages;
